class LoginModel {
    constructor(data = {}) {
      this.email = data.email || ''
      this.password = data.password || ''
      this.keepAlive = data.keepAlive || 'true'
    }
  }
  
export default LoginModel